<template>
  <div class="basic-data">
    <section class="bd-header">
      <AFHeader
        :tab="tab"
        :index="tabIndex"
        @toggletab="toggleTab"
      />
    </section>
    <section class="bd-main">
      <component :is="currentTabComponent" />
    </section>
  </div>
</template>

<script>
import '@/views/formflow/css/appflow/basicdata/index.scss'
import AFHeader from '@/views/formflow/appflow/components/header'
import formDesign from '@/views/formflow/appflow/design/components/formDesign'
import flowDesign from '@/views/formflow/appflow/design/components/flowDesign'
import printDesign from '@/views/formflow/appflow/design/components/printDesign'
export default {
  components: {
    AFHeader,
    formDesign,
    flowDesign,
    printDesign
  },
  data () {
    return {
      currentTabComponent: formDesign,
      tab: ['表单设计', '流程设计', '打印设计'],
      tabIndex: 0
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => { //  这里的vm指的就是vue实例，可以用来当做this使用
      if (from.name === 'print') {
        vm.tabIndex = 2
      }
    })
  },
  methods: {
    toggleTab (item, index) {
      switch (item) {
        case '表单设计':
          this.currentTabComponent = formDesign
          break
        case '流程设计':
          this.currentTabComponent = flowDesign
          break
        case '打印设计':
          this.currentTabComponent = printDesign
          break
        default:
          this.currentTabComponent = formDesign
      }
    }
  }
}
</script>

<style>
</style>
